import React from 'react';


class TextSuggestBox extends React.Component {

    constructor(props) {
        super(props);
    }

    handleSelect(e, text) {
        this.props.onSuggestTextSelect(text);
    }

    render() {

        let textSelects = null;
        if (this.props.perspective.suggest_texts !== undefined && this.props.perspective.suggest_texts.length > 0)
        {
            textSelects = this.props.perspective.suggest_texts.map((text, index) =>
                <li 
                    key={index}
                    onClick={(e) => this.handleSelect(e, text)}
                >{text}</li>
            );
        }
        else
            return null;

        return (
            <div className="text_suggest_box"> 
                <strong>Textvorschl&auml;ge:</strong>
                <br />
                <ul>
                    {textSelects}
                </ul>
            </div>
        );
    }
  }
export default TextSuggestBox;



// WEBPACK FOOTER //
// ./src/TextSuggestBox.js